<template>
    <span class="caption text-uppercase" style="color: rgba(0, 0, 0, 0.38)">
        {{ value }}
    </span>
</template>

<script>
export default {
    name: 'DefaultValue',
    props: {
        value: {
            type: undefined,
            default: '-'
        }
    }
};
</script>
